import { v4 as uuidv4 } from 'uuid'

export const getInitialExpertCollectionsItemData = () => ({
  caption: '',
  cmsShowroomPage: null,
  previewImageAttachment: {},
  profileImageAttachment: null,
  clientId: uuidv4(),
})
